<template>
  <div>
    <div class="backdrop" id="backdrop" @click="closeNav"></div>
    <!-- Use relative path for image reference -->
    <!-- When back button on left -->
    <div v-if="backButtonOnLeft" id="c-button--slide-left"
         class="c-button hb-menu-icon" @click="openNav"></div>
    <!-- When there is no back button on left -->
    <div v-else id="c-button--slide-left" class="c-button hb-menu-icon"
         style="position: relative; right: 40px;" @click="openNav"></div>

    <!-- Use relative path for image reference -->
    <!-- When back button on left -->
    <div class="side-nav-main-menu">
      <!-- set the width of the menu and hide it using left with its width -->
      <div id="mySidenav" class="sidenav" :style="`width:${menus.width}; left:-${menus.width};${menus.style}`">
        <!-- loop through 0 to second last of menuitem, last one is exit button, which handle below -->
        <template v-if="index < menus.items.length -1">
        <div v-for="(menuItem, index) in menus.items" :key="index"
             style="position:relative" :style="menuItem.style">
          <div :id="menuItem.id" class="cursor-pointer brightness"
               @click="hoverableAction(menuItem.hoverable)" >
            <img :src="menuItem.imageSrc" class="menu-hover"
                 @mouseover="handleMouseOver(menuItem, $event)"
                 @mouseout="handleMouseOut(menuItem, $event)"/>
            <hoverable-image v-if="menuItem.audioControl === true" :images="muteImages"
                             class="audioControl" @click.native="handleAudioControl"></hoverable-image>
          </div>
          <span v-if="menuItem.subMenu" class="menu-arrow" @click="handleSubMenuClicked(menuItem, $event)">
							<img :src="menus.subMenuArrow.imageSrc" class="arrow-hover"/>
					</span>
        </div>
        </template>

        <!-- Must define Exit as the last menuitem in the array -->
        <div :id="menus.items[menus.items.length-1].id" class="home-nav-btn cursor-pointer brightness"
             :style="menus.items[menus.items.length-1].style" @click="closeApp()">
          <img :src="menus.items[menus.items.length-1].imageSrc"
               @mouseover="handleMouseOver(menus.items[menus.items.length-1], $event)"
               @mouseout="handleMouseOut(menus.items[menus.items.length-1], $event)"/>
        </div>
      </div>

      <div :id="subMenu.id" :key=subMenu v-for="subMenu in subMenus" class="sidesubnav brightness" :style="`width: ${subMenu.width}; left: -${subMenu.width}`">
        <img :src="subMenu.imageSrc" class="menu-hover"/>
        <div :key=menuItem v-for="menuItem in subMenu.items" class="subMenuItem"
             v-bind:class="{ 'disabled': menuItem.disabled, 'debug': menuItem.debug || debug }"
             :style="menuItem.style" @click="hoverableAction(menuItem.hoverable)">
          <span v-html="menuItem.Text"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { EventBus } from '../assets/js/event-bus';
  import HoverableImage from "./Hoverable-Image";

  export default {
    name: 'side-menu',
    components: {HoverableImage},
    props: ['backButtonOnLeft'],
    created() {
      this.vars = {
        subMenuActivatedClass: 'subMenuActivated',
        activeSubMenu: undefined,
      };
    },
    mounted() {
      if (window.debug) {
        this.debug = true;
      }
    },
    data() {
      const configJSON = window.configMgr.getConfig()['sideMenu'];
      configJSON.debug = true;
      configJSON.muteImages = {
        imageSrc: './static/assets/mute.png',
        imageOver: './static/assets/mute.png'
      };
      configJSON.unmuteImages = {
        imageSrc: './static/assets/unmute.png',
        imageOver: './static/assets/unmute.png'
      };
      return configJSON;
    },
    methods: {
      handleAudioControl(){
        console.log('Audio Control is clicked');
        this.$store.state.enableAudio = !this.$store.state.enableAudio;
        console.log('Audio Control is clicked and now is ' + this.$store.state.enableAudio);
      },
      handleMouseOver(menuItem, e) {
        if (!menuItem.subMenu || (menuItem.subMenu &&
        !document.getElementById(menuItem.id).classList.contains(this.vars.subMenuActivatedClass))) {
          if (menuItem.imageOver) {
            e.target.src = menuItem.imageOver;
          }
        }
      },
      handleMouseOut(menuItem, e) {
        if (!menuItem.subMenu || (menuItem.subMenu &&
        !document.getElementById(menuItem.id).classList.contains(this.vars.subMenuActivatedClass))) {
          if (menuItem.imageSrc) {
            e.target.src = menuItem.imageSrc;
          }
        }
      },
      resetImageSrc() {
        for (let i = 0; i < this.menus.items.length; i++){
          const menuItem = this.menus.items[i];
         // first child is the img tag of the menuitem
          document.getElementById(menuItem.id).firstChild.src = menuItem.imageSrc;
        }
      },
      hoverableAction( hoverable ) {
        // console.log('hoverable action: ' + hoverable.toString());
        this.closeNav();
        this.$nextTick(() => {
          EventBus.$emit('hoverable-clicked-event', hoverable);
        });
      },
      closeApp() {
        // close window, electron app will close
        //  window.close();
        // function defined in closeApp.js
        closeApp();
      },
      openNav() {
        document.getElementById('mySidenav').style.left = '0';
        document.getElementById('backdrop').style.background = 'black';
        document.getElementById('backdrop').style.display = 'block';
      },
      hideMainMenu() {
        document.getElementById('mySidenav').style.left = `-${this.menus.width}`;
        document.getElementById('backdrop').style.background = 'none';
        document.getElementById('backdrop').style.display = 'none';
      },

      closeNav() {
        function isAnySubMenuOpen() {
          const submenus = document.querySelectorAll('.sidesubnav');
          for (let index = 0; index < submenus.length; index++) {
            // check to see if the first char is '-', if so, submenu is hidden.
            // Close the submenu by hidding the width of the submenu
            if (submenus[index].style.left[0] !== '-') {
              return true;
            }
          }
          return false;
        }
        if (isAnySubMenuOpen()) {
          const that = this;
          this.closeSubMenus();
          setTimeout(() => {
            // add a bit of delay to close the main menu if submenu is active
            that.hideMainMenu();
          }, 300);
        } else {
          this.hideMainMenu();
        }
      },
      handleSubMenuClicked(menuItem, e) {
        const lastOpenedMenu = this.vars.activeSubMenu;
        // close all submenus
        this.closeSubMenus();
        // only open submenu when it was not open before
        if (menuItem.id !== lastOpenedMenu) {
          this.openSubMenu(menuItem);
        }
      },
      closeSubMenus() {
        let menuItem;
        for (let i = 0; i < this.menus.items.length; i++){
          menuItem = this.menus.items[i];
          if (menuItem.subMenu) {
            const subMenu = window.configMgr.getResourceFromArray(menuItem.subMenu, this.subMenus);
            document.getElementById(menuItem.id).classList.remove(this.vars.subMenuActivatedClass);
            // hide the menu with submenu width
            if(document.getElementById(menuItem.subMenu)) {
              document.getElementById(menuItem.subMenu).style.left = `-${subMenu.width}`;
            } else {
              alert(`submenu ${menuItem.subMenu} does not exist in config.json but it is reference in menu`);
            }
          }
        }
        this.vars.activeSubMenu = undefined;
        this.resetImageSrc();
      },
      openSubMenu(menuItem) {
        if (menuItem.imageSelected) {
          // img is the first child of the menuItem
          document.getElementById(menuItem.id).childNodes[0].src = menuItem.imageSelected;
        }
        document.getElementById(menuItem.id).classList.add(this.vars.subMenuActivatedClass);
        document.getElementById(menuItem.subMenu).style.left = this.menus.width;
        this.vars.activeSubMenu = menuItem.id;
      },
    },
  };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" rel="stylesheet/css">
  .audioControl{

  }

  .sidenav {
    height: 100%;
    position: absolute;
    top: 0;
    background-color: #1553A1;
    transition: 0.3s;
    padding-top:0px;
    z-index: 99;
    overflow: hidden;
    /*text-align: center*/
  }

  #backdrop {
    position:absolute;
    top: 0px;
    width:100%;
    height:100%;
    opacity:0.5;
    background-color:rgb(0,0,0);
    z-index:11 !important;
    display:none;
  }

  .sidesubnav {
    height: 100%;
    position: absolute;
    top: 0;
    background-color: #1553A1;
    overflow-x: hidden;
    transition: 0.3s;
    padding-top:0px;
    z-index: 97;
    /*text-align: center*/
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .menu-arrow {
    position: absolute;
    top: 0;
    right: 0;
    height: 225px;
    width: auto;
    display: block;
    cursor: pointer;
  }

  .brightness {
    background-color: white;
    display: inline-block;

  }

  .brightness img:hover {
    opacity: 0.8;
  }

  .arrow-hover {
    opacity: 0.6
  }

  .arrow-hover:hover {
    opacity: 1
  }

  .debug {
    border-style: solid;
    border-color: red;
    border-width: 2px;
  }

  .subMenuItem {
    /*background: red;*/
    position: absolute;
    opacity: 0.8;
    left: 81px;
    height: 45px;
    width: 100%;
    cursor: pointer;
  }

  .subMenuItem:not(.no-highlight):hover {
    border-bottom: 1px solid #fff;
    opacity: 0.7;
  }

  .hb-menu-icon {
    background: url(~assets/images/burger_menu.png) no-repeat;
    /*margin: 18px 0 0 75px;*/
    margin: 36px 0 0 3.90625%;
    position: absolute;
    width: 33px;
    height: 27px;
    z-index: 15;
    padding: 20px;
  }

  .no-back-button-on-left {
    position: relative;
    right: 40px;
  }

  .disabled{
    cursor: inherit !important;
  }

</style>



// WEBPACK FOOTER //
// TheSideMenu.vue?47df6296